import { useState } from 'react';
import FieldNameWrapper from 'components/TaskChecklist/Items/TemplateItem/Fields/common/FieldNameWrapper';
import FileUpload from 'components/FileUpload';

const UploadFile = ({
  item,
  answers = null,
  disabled,
  onChangeCb,
  showTimeStamp,
}: any) => {
  const [value, setValue] = useState(answers?.value ?? []);

  const handleChange = (filesUrls, otherProps = {}) => {
    if (disabled) return;
    if (onChangeCb) {
      const updatedValues = [...(filesUrls ?? [])];
      setValue(updatedValues);
      onChangeCb && onChangeCb(updatedValues, otherProps);
    }
  };

  return (
    <FieldNameWrapper
      fieldName={item.description}
      item={item}
      showTimeStamp={showTimeStamp}
    >
      <FileUpload
        onChangeCb={handleChange}
        attachments={value}
        thumbnails={answers?.thumbnails}
      />
    </FieldNameWrapper>
  );
};

export default UploadFile;
